'use client';
import { useContext, useEffect, useState } from 'react';

import { ThemeContext } from '@susu/custom-made/providers';
import { OnBoardingTipItem } from '../onBoardingTipItem/onBoardingTipItem';

export const OnBoardingTips = () => {
  const visitedStorageName = 'cm_visited_products_tips';
  const { state } = useContext(ThemeContext);
  const [isShown, setIsShown] = useState<boolean>(false);

  const saveStorage = () => {
    const currentProduct = state.product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    let visitedProductArray = [currentProduct];
    if (visitedProductStorage) {
      visitedProductArray = [...visitedProductStorage.split(','), ...visitedProductArray];
    }
    localStorage.setItem(visitedStorageName, visitedProductArray.join(','));
  }

  const checkStorage = () => {
    const currentProduct = state.product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    return (visitedProductStorage && visitedProductStorage.split(',').indexOf(currentProduct) >= 0);
  }

  useEffect(() => {
    if (!checkStorage()) {
      setTimeout(() => {
        setIsShown(true);
      }, 1000);
    }
  }, []);

  return (
    <>
      <OnBoardingTipItem
        isShown={isShown}
        hideTooltip={() => {setIsShown(false)}}
        saveStorage={saveStorage}
      ></OnBoardingTipItem>
    </>
  );
};
